import { find } from 'lodash';
import app from '../../angular_app.es6';

app.controller('WordcloudScreenshotController', [ '$scope', 'OrientationService', ($scope, OrientationService) => {
  $scope.data = {};

  $scope.init = (data) => {
    $scope.data = data.data;
    $scope.metric = data.metric;
    $scope.orientation = find(OrientationService.customList, (el) => el.name == data.orientation);
  };
} ]);
